import { cn } from '@/lib/utils';

/** Mobile pill group — matches /new-trip Import / Roam / Explore. */
export const ROUNDED_SEGMENT_GROUP_CLASS =
  'grid min-w-0 flex-1 grid-cols-3 rounded-full bg-[#eceae6] p-1';

export function roundedSegmentItemClass(active: boolean, className?: string) {
  return cn(
    'rounded-full px-1 py-1.5 text-center text-[13px] font-semibold leading-none transition',
    active ? 'bg-white text-[#FA5E4F] shadow-sm' : 'text-[#181715]/55 hover:text-[#181715]',
    className,
  );
}
